// تابع تبدیل متن فارسی و انگلیسی به slug
export const createSlug = (text) => {
  if (!text) return '';
  
  return text
    .toString()
    .toLowerCase()
    .trim()
    // تبدیل کاراکترهای فارسی به معادل انگلیسی
    .replace(/[آ]/g, 'a')
    .replace(/[ا]/g, 'a')
    .replace(/[ب]/g, 'b')
    .replace(/[پ]/g, 'p')
    .replace(/[ت]/g, 't')
    .replace(/[ث]/g, 'th')
    .replace(/[ج]/g, 'j')
    .replace(/[چ]/g, 'ch')
    .replace(/[ح]/g, 'h')
    .replace(/[خ]/g, 'kh')
    .replace(/[د]/g, 'd')
    .replace(/[ذ]/g, 'z')
    .replace(/[ر]/g, 'r')
    .replace(/[ز]/g, 'z')
    .replace(/[س]/g, 's')
    .replace(/[ش]/g, 'sh')
    .replace(/[ص]/g, 's')
    .replace(/[ض]/g, 'z')
    .replace(/[ط]/g, 't')
    .replace(/[ظ]/g, 'z')
    .replace(/[ع]/g, 'a')
    .replace(/[غ]/g, 'gh')
    .replace(/[ف]/g, 'f')
    .replace(/[ق]/g, 'gh')
    .replace(/[ک]/g, 'k')
    .replace(/[گ]/g, 'g')
    .replace(/[ل]/g, 'l')
    .replace(/[م]/g, 'm')
    .replace(/[ن]/g, 'n')
    .replace(/[و]/g, 'v')
    .replace(/[ه]/g, 'h')
    .replace(/[ی]/g, 'y')
    .replace(/[ئ]/g, 'y')
    .replace(/[ة]/g, 'h')
    .replace(/[أ]/g, 'a')
    .replace(/[إ]/g, 'e')
    .replace(/[ؤ]/g, 'v')
    .replace(/[ء]/g, 'a')
    // حذف کاراکترهای خاص و تبدیل به خط تیره
    .replace(/[^a-z0-9\u0600-\u06FF]/g, '-')
    // حذف خط تیره های تکراری
    .replace(/-+/g, '-')
    // حذف خط تیره از ابتدا و انتها
    .replace(/^-+|-+$/g, '');
};

// تابع تولید URL حرفه‌ای برای محصول
export const createProductUrl = (product, business) => {
  if (!product || !product.name) return `/service/${product._id}`;
  
  const businessName = business?.companyName || 'business';
  const productName = product.name;
  
  // ایجاد slug برای نام کسب‌وکار و محصول
  const businessSlug = createSlug(businessName);
  const productSlug = createSlug(productName);
  
  // اگر slug خالی است، از ID استفاده کن
  if (!businessSlug && !productSlug) {
    return `/service/${product._id}`;
  }
  
  // ساخت URL: /service/business-name/product-name-id
  if (businessSlug && productSlug) {
    return `/service/${businessSlug}/${productSlug}-${product._id}`;
  }
  
  // اگر فقط نام کسب‌وکار موجود است
  if (businessSlug) {
    return `/service/${businessSlug}/${product._id}`;
  }
  
  // اگر فقط نام محصول موجود است
  if (productSlug) {
    return `/service/${productSlug}-${product._id}`;
  }
  
  // fallback به ID
  return `/service/${product._id}`;
};

// تابع تولید URL کوتاه برای محصول
export const createShortProductUrl = (product, business) => {
  if (!product || !product.name) return `/service/${product._id}`;
  
  const businessName = business?.companyName || 'business';
  const productName = product.name;
  
  // ایجاد slug برای نام کسب‌وکار و محصول
  const businessSlug = createSlug(businessName);
  const productSlug = createSlug(productName);
  
  // ساخت URL کوتاه: /service/business-product-id
  if (businessSlug && productSlug) {
    return `/service/${businessSlug}-${productSlug}-${product._id}`;
  }
  
  // fallback
  return `/service/${product._id}`;
};

// تابع تولید URL با نام شرکت اول
export const createCompanyFirstUrl = (product, business) => {
  // بررسی وجود product و business
  if (!product) {
    console.warn('createCompanyFirstUrl: product is undefined or null');
    return '/service/undefined';
  }
  
  if (!business?.companyName) {
    console.warn('createCompanyFirstUrl: business or business.companyName is undefined');
    return `/service/${product._id || 'undefined'}`;
  }
  
  const businessName = business.companyName;
  const productName = product.name;
  
  // بررسی وجود نام محصول
  if (!productName) {
    console.warn('createCompanyFirstUrl: product.name is undefined');
    return `/service/${product._id || 'undefined'}`;
  }
  
  // ایجاد slug
  const businessSlug = createSlug(businessName);
  const productSlug = createSlug(productName);
  
  // ساخت URL: /service/company-name/product-name-id
  if (businessSlug && productSlug) {
    // اطمینان از اینکه productSlug خیلی طولانی نباشد
    const shortProductSlug = productSlug.length > 20 ? productSlug.substring(0, 20) : productSlug;
    return `/service/${businessSlug}/${shortProductSlug}-${product._id}`;
  }
  
  // fallback
  return `/service/${product._id || 'undefined'}`;
};
